import React, { useEffect, useState } from "react";
import CustomSelect from "../form/CustomSelect";
import "react-datepicker/dist/react-datepicker.css"; // Importar los estilos necesarios
import SingleCalendarDateRangePicker from "../form/SingleCalendarDateRangePicker";
import { getStatuses, plansResource } from "../../helpers/configRoutes/backend_helper";
import { useDispatch } from "react-redux";
import { update_pagination } from "../../store/pagination/action";


const FiltersPagination = ({ meta, children, filters, setFilters, showFilters, statusModel, readuxPag }) => {
    const dispatch = useDispatch()
    const [showCalendar, setShowCalendar] = useState(false);
    const [statuses, setStatuses] = useState([]);
    const [plans, setPlans] = useState([]);
    useEffect(() => {
        const getFilters = async () => {

        };
        if (showFilters) {
            getFilters();
        }
    }, [showFilters]);



    const changePagReadux = () => {
        const newPagination = {
            model: 'salesPag',
            pagination: {
                search: filters.search,
                perPage: filters.perPage,
                page: filters.page
            }
        }
        if (readuxPag) {
            dispatch(update_pagination(newPagination))
        }
    }





    return (
        <>
            {children}
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-2 py-2">
                {/* Showing results text */}
                <div className="text-gray-500 flex items-center gap-2">
                    Showing <span className="font-semibold">{meta.from}-{meta.to}</span> of <span className="font-semibold">{meta.total}</span>
                </div>

                {/* Rows per page selector */}
                <div className="flex items-center gap-2">
                    <span className="text-gray-500">Rows per page:</span>
                    <select
                        value={filters.perPage}
                        onChange={(e) =>
                            [setFilters({ ...filters, page: 1, perPage: parseInt(e.target.value) }),changePagReadux()]
                        }
                        className="border rounded-lg px-2 py-1 text-gray-700 focus:outline-none focus:ring"
                    >
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </div>

                {/* Pagination arrows */}
                <div className="flex items-center space-x-1">
                    {/* Previous Button */}
                    <button
                        className="flex items-center justify-center w-8 h-8 border rounded-lg hover:bg-gray-200 focus:outline-none"
                        disabled={filters.page == 1}
                        onClick={() => [setFilters({ ...filters, page: filters.page - 1 }),changePagReadux()]}
                    >
                        <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M15 19l-7-7 7-7"
                            ></path>
                        </svg>
                    </button>

                    {/* Next Button */}
                    <button
                        className="flex items-center justify-center w-8 h-8 border rounded-lg hover:bg-gray-200 focus:outline-none"
                        disabled={meta.last_page == filters.page}
                        onClick={() => [setFilters({ ...filters, page: filters.page + 1 }),changePagReadux()]}
                    >
                        <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M9 5l7 7-7 7"
                            ></path>
                        </svg>
                    </button>
                </div>
            </div>

        </>
    )
}

export default FiltersPagination;